import React from 'react';
import { Link } from 'react-router-dom';
import { User, DollarSign, Calendar } from 'lucide-react';
import KanbanBoard from './KanbanBoard';
import { formatCurrency } from '../utils/formatCurrency';

const STATUS_COLUMNS = [
  { key: 'Draft', label: 'Draft', color: 'gray' },
  { key: 'Sent', label: 'Sent', color: 'primary' },
  { key: 'Accepted', label: 'Accepted', color: 'success' },  // Read-only column (set via Convert to Order)
  { key: 'Rejected', label: 'Rejected', color: 'danger' },
];

function QuotesKanban({ quotes, onStatusChange, canEdit = true }) {
  const columns = STATUS_COLUMNS.map((col) => ({
    id: col.key,
    title: col.label,
    color: col.color,
    items: quotes.filter((quote) => quote.status === col.key),
  }));

  const handleCardMove = (cardId, fromColumnId, toColumnId) => {
    onStatusChange(cardId, toColumnId);
  };

  const getColumnTotal = (items) => {
    return items.reduce((sum, quote) => sum + (quote.total || 0), 0);
  };

  const renderColumnHeader = (column) => (
    <>
      <div className="kanban-column-title">
        <span className="kanban-stage-name">{column.title}</span>
        <span className="kanban-stage-count">{column.items.length}</span>
      </div>
      <div className="kanban-column-total">
        {formatCurrency(getColumnTotal(column.items))}
      </div>
    </>
  );

  const renderCard = (quote) => (
    <>
      <Link to={`/quotes/${quote.id}`} className="kanban-card-title">
        {quote.quote_number || `Quote #${quote.id}`}
      </Link>
      {quote.account_name && (
        <Link to={`/accounts/${quote.account_id}`} className="kanban-card-account">
          {quote.account_name}
        </Link>
      )}
      <div className="kanban-card-details">
        <div className="kanban-card-amount">
          <DollarSign size={12} />
          {formatCurrency(quote.total)}
        </div>
        {quote.created_at && (
          <div className="kanban-card-date">
            <Calendar size={12} />
            {new Date(quote.created_at).toLocaleDateString()}
          </div>
        )}
      </div>
      {quote.owner_name && (
        <div className="kanban-card-owner">
          <User size={12} />
          {quote.owner_name}
        </div>
      )}
    </>
  );

  return (
    <KanbanBoard
      columns={columns}
      onCardMove={handleCardMove}
      renderCard={renderCard}
      renderColumnHeader={renderColumnHeader}
      getItemId={(quote) => quote.id}
      getItemColumnId={(quote) => quote.status}
      canDrag={canEdit ? (quote) => quote.status !== 'Rejected' && quote.status !== 'Accepted' : false}
      emptyMessage={canEdit ? 'Drop quotes here' : 'No quotes'}
    />
  );
}

export default QuotesKanban;
